import { Container, Heading, Text } from '@radix-ui/themes';
import type { ErrorComponentProps } from '@tanstack/react-router';

export const ErrorComponent = ({ error }: ErrorComponentProps) => {
  const message =
    error &&
    typeof error === 'object' &&
    'message' in error &&
    typeof error.message === 'string'
      ? error.message
      : '';
  return (
    <Container size="2" className="py-8">
      <Heading size="8" className="mb-4">
        Something went wrong!
      </Heading>
      <Text as="p" color="red" size="3">
        {message}
      </Text>
    </Container>
  );
};
